export default (num, currency = 'Rp ', decimals = 0) => {
	// console.log({num});
	
	const format = typeof(num);
	(format === 'string') ? ( num = Number(num).toFixed(decimals).toString() ) : 
	(format === 'number') ? ( num = num.toFixed(decimals).toString() ) :
	num = (0).toString();
	const breakNum = num.split('.');

	return `${currency}${breakNum[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}${decimals >0 && ','+breakNum[1]}`
}